<script lang="ts">
  import { v4 as v4uuid } from "uuid";
  import { createEventDispatcher } from "svelte";
  import { Icon } from "sveltestrap";
  import type { Vehicle } from "../Model/Vehicle";
  import { vehiclesService } from "../services";
  import type VehicleData from "./VehicleData.svelte";

  export const vehicleId: string = null;

  const dispatch = createEventDispatcher();

  let vehicles: Vehicle[];
  
  let offset: number = 0;
  let limit: number = 10;
  let searchFilter: string = null;

  let vehicle: Vehicle;
  let vehicleDataForm: VehicleData;

  $: searchVehicle(searchFilter);

  async function searchVehicle(searchFilter: string | null) {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: searchFilter
      }
    }

    vehicles = await vehiclesService.findVehicles(opts);
    
  }

  async function changeVehicle(vehicle: Vehicle){
		dispatch("changeVehicle", vehicle.id);
	}

  async function saveVehicle() {
    await Promise.all([ vehicleDataForm.saveVehicleData() ])
    changeVehicle(vehicle);
  }

</script>


      <div class="row">
        <div class="col-12">
          <form on:submit|preventDefault={() => {searchVehicle(null)}}>
            <div class="input-group">
              <input 
                class="form-control"
                type="text"
                placeholder="Introduzca la Matricula"
                on:input={() => {searchVehicle(searchFilter)}}
                bind:value={searchFilter} />
              <button
                class="btn btn-secondary"
                type="submit">
                <Icon name="search" />
              </button>
            </div>
          </form>

        </div>
        <div class="col-12" style="height:400px; overflow:auto;">
          <table style="width: 100%">
            <thead>
              <th scope="col">Matricula</th>
              <th scope="col"></th>
            </thead>
            <tbody>
              {#if vehicles?.length}
                {#each vehicles as vehicle}
                  <tr>
                    <td>
                      {vehicle.plate}
                    </td>
                    <td class="text-end">
                      <button
                        class="btn btn-success btn-sm"
                        type="button"
                        on:click={() => {changeVehicle(vehicle)}}>
                        <Icon name="check" />
                      </button>
                    </td>
                  </tr>
                {/each}
              {/if}
              <tr>
                <td>Crear</td>
                <td class="text-end">
                  <a
                    href='/vehiculo/new'
                    target='_blank'
                    class="btn btn-primary btn-sm text-white"
                    type="button">
                    <Icon name="plus" />
                </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>